import styled from 'styled-components';

import { size } from '../../layout/helpers';
import { ButtonReset, inputPlaceholder } from '../../layout/reset';
import { Button } from '../Button';

export const Wrapper = styled.div.withConfig({ componentId: 'sc-1sgvh8i-0' })`
    --_height: ${(props) => props.theme.size.inputHeight};
    --_spacing-inline-start: ${size(3)};
    --_spacing-inline-end: ${size(1.5)};

    color: var(--c-text-main);
    position: relative;
    z-index: 10;
    height: var(--_height);
`;

export const Inner = styled.div.withConfig({ componentId: 'sc-1sgvh8i-1' })`
    position: relative;
    border-radius: ${size(3)};
    background-color: var(--c-bg-main);
    z-index: 1;

    &::before {
        content: "";
        position: absolute;
        inset: 0;
        background-color: inherit;
        border-radius: inherit;
        user-select: none;
        filter: drop-shadow(0px 8px 8px rgba(0, 0, 0, 0.03)) drop-shadow(0px 8px 8px rgba(0, 0, 0, 0.03)) drop-shadow(0px 5px 4px rgba(0, 0, 0, 0.09));
        z-index: -1;
    }
`;

export const InputWrapper = styled.div.withConfig({ componentId: 'sc-1sgvh8i-2' })`
    position: relative;
    display: flex;
    align-items: center;
    height: var(--_height);

    ${Button} {
        margin-right: calc((var(--_height) - 34px) / 2);
    }
`;

export const Input = styled.input.withConfig({ componentId: 'sc-1sgvh8i-3' })`
    ${inputPlaceholder};
    display: block;
    width: 100%;
    height: 100%;
    padding-top: 0;
    padding-bottom: 0;
    margin: 0;
    padding-left: var(--_spacing-inline-start);
    padding-right: var(--_spacing-inline-end);
    background-color: transparent;
    font-size: var(--font-size-input);
    border: none;
    box-shadow: none;
    appearance: none;

    &:focus {
        outline: none;
    }

    &[disabled] {
        opacity: 0.37;
        cursor: not-allowed;
    }
`;

export const ClearButton = styled(ButtonReset).withConfig({ componentId: 'sc-1sgvh8i-4' })`
    --_hitbox: ${size(1)};

    margin-left: calc(var(--_spacing-inline-end) * -1);
    margin-right: var(--_hitbox);
    padding: ${size(0.5)};
    border-radius: 50%;
    background-color: var(--c-bg-alt);
    color: var(--c-text-main);
    font-size: var(--font-size-small);
    transform-origin: 50% 50%;
    transition: transform 200ms ease;
    user-select: none;
    cursor: pointer;

    &::before,
    &::after {
        content: "";
        position: absolute;
    }

    &::before {
        inset: 1px;
        background-color: var(--c-overlay);
        border-radius: inherit;
        mix-blend-mode: soft-light;
        opacity: 0;
        transition: opacity 200ms ease;
    }

    &::after {
        inset: calc(var(--_hitbox) * -1);
    }

    &:active {
        transform: scale(0.97);
    }

    &:not([disabled]):hover {
        &::before {
            opacity: 1;
        }
    }
`;

export const Meta = styled.div.withConfig({ componentId: 'sc-1sgvh8i-5' })`
    flex-shrink: 0;
    padding-right: var(--_spacing-inline-end);
    color: var(--c-text-muted);
    font-size: ${(props) => props.theme.font.size.small};
`;
